export default __webpack_public_path__ + "static/media/ProximaNovaRegular.ea03f826.otf";